import React from "react";

const Cross = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.16003 4.74994L8.99003 1.91994C9.09471 1.8303 9.17973 1.71998 9.23976 1.59591C9.29978 1.47185 9.33351 1.33672 9.33883 1.199C9.34415 1.06128 9.32094 0.923946 9.27067 0.795621C9.22039 0.667296 9.14414 0.550748 9.04668 0.453294C8.94923 0.355839 8.83268 0.279581 8.70435 0.229307C8.57603 0.179032 8.4387 0.155826 8.30098 0.161146C8.16326 0.166465 8.02813 0.200195 7.90406 0.260219C7.78 0.320242 7.66968 0.405263 7.58003 0.509944L4.75003 3.33994L1.92003 0.509944C1.72873 0.346118 1.48265 0.260511 1.23098 0.270233C0.979301 0.279954 0.740562 0.384286 0.562468 0.562381C0.384373 0.740475 0.280041 0.979215 0.270319 1.23089C0.260598 1.48257 0.346205 1.72864 0.510031 1.91994L3.34003 4.74994L0.510031 7.57994C0.32378 7.76731 0.219238 8.02076 0.219238 8.28494C0.219238 8.54913 0.32378 8.80258 0.510031 8.98994C0.697394 9.17619 0.950845 9.28074 1.21503 9.28074C1.47922 9.28074 1.73267 9.17619 1.92003 8.98994L4.75003 6.15994L7.58003 8.98994C7.76739 9.17619 8.02084 9.28074 8.28503 9.28074C8.54922 9.28074 8.80267 9.17619 8.99003 8.98994C9.17628 8.80258 9.28082 8.54913 9.28082 8.28494C9.28082 8.02076 9.17628 7.76731 8.99003 7.57994L6.16003 4.74994Z"
        fill="red"
      />
    </svg>
  );
};

export default Cross;
